<ng-container *apSecure='[Permissions.MANAGE_REFUND]'>
  <!-- ORDER ITEM REFUND PANEL CONTENT -->
  @if (order?.orderItems) {
    <div *apSecure='[Permissions.ACCESS_ALL_ORDERS]' [ngClass]="{ 'watermark-wrapper': !isSelectBlockActive }" (focusin)='onFocusInTable()' tabindex='0' style='margin-bottom: 2rem;'>
      <ap-panel>
        <ap-panel-title>
          @if (userView) {
            <button panel-button (click)='backToTransactions()' type='button' class='btn btn-default button-panel-position'>{{ 'USER.TABS.TRANSACTIONS.TRANSACTION_DETAILS.CLOSE_PANEL' | translate }}</button>
          }
        {{ 'TRANSACTIONS.REFUND.SELECT_REFUND.TITLE' | translate }}</ap-panel-title>
        <ap-panel-content>
          <div class='table-responsive order-items-array'>
            <table mat-table #orderItemsTable [dataSource]='order.orderItems' id='datatable' class='table table-hover table-bordered table-fixed no-footer' role='grid' aria-describedby='datatable_info'>
              <ng-container matColumnDef='{{ displayedColumns[0] }}'>
                <!-- SELECT -->
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox
                    (change)='$event ? masterToggle() : null'
                    [checked]='selection.hasValue() && isAllSelected()'
                    [indeterminate]='selection.hasValue() && !isAllSelected()'
                  ></mat-checkbox>
                </th>
                <td mat-cell *matCellDef='let orderItem'>
                  <mat-checkbox
                    [disabled]='orderItem.quantityRefunded != null && orderItem.quantityRefunded > 0'
                    (click)='$event.stopPropagation()'
                    (change)='$event ? selection.toggle(orderItem) : null'
                    [checked]='selection.isSelected(orderItem)'
                  ></mat-checkbox>
                </td>
                <td mat-footer-cell *matFooterCellDef [attr.colspan]='5'></td>
              </ng-container>
              <!-- REFUND STATE -->
              <ng-container matColumnDef='{{ displayedColumns[1] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[1] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>
                  @if (orderItem.quantityRefunded) {
                    <status-label type='TRANSACTIONS.TYPE' status='REFUND'></status-label>
                  }
                  @if (!orderItem.quantityRefunded) {
                    -
                  }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <!-- PRODUCT NAME -->
              <ng-container matColumnDef='{{ displayedColumns[2] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[2] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>{{ (orderItem?.reference ? orderItem.reference + ' ' : '') + orderItem?.label | noData }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <!-- SERVICE NAME -->
              <ng-container matColumnDef='{{ displayedColumns[3] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[3] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>{{ orderItem.serviceProvider | noData }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <!-- QUANTITY -->
              <ng-container matColumnDef='{{ displayedColumns[4] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[4] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>{{ orderItem.quantity | noData }}</td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <!-- UNITARY AMOUNT -->
              <ng-container matColumnDef='{{ displayedColumns[5] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[5] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>{{ orderItem.unitaryAmount | apCurrency | noData }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.FOOTER.TOTAL' | translate }}</td>
              </ng-container>
              <!-- AMOUNT -->
              <ng-container matColumnDef='{{ displayedColumns[6] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[6] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>{{ orderItem.totalAmount | apCurrency | noData }}</td>
                <td mat-footer-cell *matFooterCellDef>{{ order.totalAmount | apCurrency | noData }}</td>
              </ng-container>
              <!-- ACTIONS -->
              <ng-container matColumnDef='{{ displayedColumns[7] }}'>
                <th mat-header-cell *matHeaderCellDef>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.ORDER_ITEM_LIST.COLUMNS.' + displayedColumns[7] | translate }}</th>
                <td mat-cell *matCellDef='let orderItem'>@if (orderItem?.description || (orderItem?.additionalInformation && orderItem?.additionalInformation.size > 0)) {
                  <button (click)='showOrderItemDetails(orderItem)' class='btn btn-xs btn-default'>{{ 'TRANSACTIONS.LIST.BUTTONS.DETAILS' | translate }}</button>
                }</td>
                <td mat-footer-cell *matFooterCellDef></td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef='displayedColumns'></tr>
              <tr mat-row *matRowDef='let row; columns: displayedColumns;'></tr>
              <tr mat-footer-row *matFooterRowDef='displayedColumnsFooter'></tr>
            </table>
          </div>
          <form [formGroup]='selectRefundForm' (ngSubmit)='submitSelectedRefund()' autocomplete='off' class='form-horizontal form-label-left'>
            <div class='row'>
              <div class='col-sm-6 col-md-6 col-xs-6'>
                <!-- REFUND COMMENT -->
                <div class='form-group'>
                  <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.COMMENT' | translate }}*</label>
                  <div class='col-sm-7 col-md-7 col-xs-7'>
                    <textarea class='form-control' rows='3' formControlName='commentSelect'></textarea>
                    @if (commentSelect.dirty || commentSelect.touched) {
                      <div class='form-group'>
                        @if (commentSelect?.errors?.required) {
                          <span class='help-block'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.ERRORS.REQUIRED' | translate }}</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <button type='submit' [disabled]='selection.isEmpty() || selectRefundForm.invalid' class='btn btn-primary pull-right'>{{ 'TRANSACTIONS.REFUND.SELECT_REFUND.BUTTONS.REFUND' | translate }}</button>
          </form>
        </ap-panel-content>
      </ap-panel>
    </div>
  }

  <!-- MANUAL REFUND PANEL CONTENT -->
  <div [ngClass]="{ 'watermark-wrapper': isSelectBlockActive }" (focusin)='onFocusInInput()' tabindex='1'>
    <ap-panel>
      <ap-panel-title>
        @if (userView && (!order?.orderItems || order?.orderItems.length === 0)) {
          <button panel-button (click)='backToTransactions()' type='button' class='btn btn-default button-panel-position'>{{ 'USER.TABS.TRANSACTIONS.TRANSACTION_DETAILS.CLOSE_PANEL' | translate }}</button>
        }
        {{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.TITLE' | translate }}
      </ap-panel-title>
      <ap-panel-content>
        <div >
          <form [formGroup]='manualRefundForm' (ngSubmit)='onSubmitManualRefundForm()' autocomplete='off' class='form-horizontal form-label-left'>
            <div class='row'>
              <div class='col-sm-6 col-md-6 col-xs-6'>
                <!-- AMOUNT INITIAL TRANSACTION -->
                <div class='form-group'>
                  <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.INITIAL_TRANSACTION_AMOUNT' | translate }}</label>
                  <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.amount | apCurrency | noData }}</div>
                </div>

                <!-- AMOUNT ALREADY REFUNDED -->
                <div class='form-group'>
                  <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.TRANSACTION_AMOUNT_REFUNDED' | translate }}</label>
                  <div class='col-sm-7 col-md-7 col-xs-7'>{{ transaction.amountRefunded | apCurrency | noData }}</div>
                </div>

                <!-- AMOUNT TO REFUND -->
                <div class='form-group'>
                  <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.TRANSACTION_AMOUNT_TO_REFUND' | translate }}*</label>
                  <div class='col-sm-7 col-md-7 col-xs-7'>
                    <input type='text' id='amountToRefund' name='amountToRefund' inputmode='numeric' class='form-control' formControlName='amountToRefund'/>
                    @if (amountToRefund.dirty || amountToRefund.touched) {
                      <div class='form-group'>
                        @if (amountToRefund?.errors?.pattern) {
                          <span class='help-block'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.ERRORS.PATTERN' | translate }}</span>
                        }
                        @if (amountToRefund?.errors?.required) {
                          <span class='help-block'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.ERRORS.REQUIRED' | translate }}</span>
                        }
                        @if (amountToRefund?.errors?.positiveAmount) {
                          <span class='help-block'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.ERRORS.POSITIVE_AMOUNT' | translate }}</span>
                        }
                      </div>
                    }
                  </div>
                </div>

                <!-- REFUND COMMENT -->
                <div class='form-group'>
                  <label class='col-sm-5 col-md-5 col-xs-5'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.COMMENT' | translate }}*</label>
                  <div class='col-sm-7 col-md-7 col-xs-7'>
                    <textarea class='form-control' rows='3' formControlName='commentManual'></textarea>
                    @if (commentManual.dirty || commentManual.touched) {
                      <div class='form-group'>
                        @if (commentManual?.errors?.required) {
                          <span class='help-block'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.ERRORS.REQUIRED' | translate }}</span>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div class='row'>
              <div class='col-sm-12 col-md-12 col-xs-12'>
                <button type='submit' [disabled]='manualRefundForm.invalid' class='btn btn-primary pull-right'>{{ 'TRANSACTIONS.REFUND.MANUAL_REFUND.BUTTONS.REFUND' | translate }}</button>
              </div>
            </div>
          </form>
        </div>
      </ap-panel-content>

    </ap-panel>
  </div>
</ng-container>
